import { AccountsShell } from '../AccountsShell';
import { CardSkeleton } from './CardSkeleton';

/**
 * FeedSkeleton — Suspense fallback while route JS is downloading.
 *
 * Only renders the outer chrome (nav rail + sidebar shimmer). The content
 * area shows skeleton cards so there's no jarring transition when the route
 * mounts and fills it with real data.
 */
export function FeedSkeleton() {
  return (
    <AccountsShell isLoadingAccounts>
      <div className="flex-1 overflow-auto p-6 space-y-4">
        {Array.from({ length: 4 }, (_, i) => <CardSkeleton key={i} />)}
      </div>
    </AccountsShell>
  );
}
